import { useState, useCallback } from 'react';

const FAST_MODE_KEY = 'askaldo-fast-mode-preference';
const DEFAULT_FAST_MODE = false; // Precise mode ON by default (more accurate filters)

export interface UseFastModeReturn {
  fastMode: boolean;
  setFastMode: (enabled: boolean) => void;
  toggleFastMode: () => void;
}

export const useFastMode = (): UseFastModeReturn => {
  const [fastMode, setFastModeState] = useState<boolean>(() => {
    // Initialize from localStorage
    try {
      const stored = localStorage.getItem(FAST_MODE_KEY);
      if (stored !== null) {
        return stored === 'true';
      }
    } catch (error) {
      console.warn('Failed to load fast mode preference:', error);
    }
    return DEFAULT_FAST_MODE;
  });

  const setFastMode = useCallback((enabled: boolean) => {
    setFastModeState(enabled);
    
    // Persist to localStorage
    try {
      localStorage.setItem(FAST_MODE_KEY, enabled.toString());
    } catch (error) {
      console.warn('Failed to save fast mode preference:', error);
    }
  }, []);

  const toggleFastMode = useCallback(() => {
    setFastMode(!fastMode);
  }, [fastMode, setFastMode]);

  return {
    fastMode,
    setFastMode,
    toggleFastMode
  };
};

